
















































































import { Component, Vue } from 'vue-property-decorator'
import TableComponent from '@/components/TableComponent'
import MainHeader from '@/components/MainHeader'
import moment from 'moment'
import {
  getTempDocList,
  delDocTemp
} from '@/api/system'

@Component({
  components: { TableComponent, MainHeader },
})
export default class SceneSupervision extends Vue {
  $refs!: { table: HTMLFormElement };
  private showDetail: boolean = false;

  private industryList: any = [];
  private nameList: any[] = [];
  private searchParams:any = {
    regionCode: null,
    industryCode: null,
    enterpriseCode: undefined,
    
    enterpriseName: null,

  };
  private pageOption = {
    showTotal: (total: any) => `共 ${total} 条`,
    current: 1,
    total: 0,
    size: '10',
  };
  private regionList: any[] = [];
  private fetching: boolean = false; // 查询时的loading
  private detailParams: any = { time: '', id: null, warehouseId: '' };
  private handleDetail(obj: any) {
    this.detailParams.id = obj.id
    this.detailParams.warehouseId = obj.warehouseId
    this.showDetail = true
  }

  private format: string = 'YYYY-MM-DD';
  private showEdit: boolean = false;
  private suplier: boolean = false;
  private showBook: boolean = false;
  private showPrint: boolean = false;

  private bookType: number = 0;
  private orderId: string = '';
  private handleEdit(obj: any) {
    this.$router.push({
      path: '/system/tempmange/add',
      query: { action: 'update', id: obj.id },
    })
    // this.showEdit = true
  }
  private handleshowSuplier(obj: any) {
    this.orderId = obj.id
    this.suplier = true
    this.$router.push({
      path: '/supervisionWriten/supervisionInfo',
      query: { action: 'view', id: obj.enterpriseCustId,status:obj.status },
    })
  }

handledel(value:any){
  const _taht = this
 this.$confirm({
      title: '删除提示',
      content: '确定要删除当前文书模板？',
      cancelText: '取消',
      okText: '确认',
      icon: 'exclamation-circle',
      onOk() {
     
         delDocTemp(value.id).then((res:any)=>{
        if(res&&res.status===0){
            _taht.$message.success('删除成功')
        } else {
            _taht.$message.error(res.message)
        }
        _taht.$refs.table.refresh(true)
    })
      },
    })

   
}
  handleAdd() {
    this.$router.push('/system/tempmange/add')
  }
  private handleClose() {
    this.showEdit = false
    this.showBook = false
  }
  private columns: any[] = [
    {
      title: '模板名称',
      dataIndex: 'documentName',
      ellipsis: true,
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      ellipsis: true,
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      width: 250,
      scopedSlots: { customRender: 'action' },
    },
  ];
 
 
  private tableData = [];

  private getList = getTempDocList;
  // 分页请求参数 这里可以做一些请求参数的自定义
  private setParams() {
    const data = { ...this.searchParams }
    return data
  }
  handleSearch() {
  
    this.$refs.table.refresh(true)
  }

  handleResert() {
    this.searchParams={}
    this.$refs.table.refresh(true)
  }
  private pageClick(value: number) {}
  created() {

  }
}
